import { render } from "./header-user.vue?vue&type=template&id=53311009&scoped=true"
import script from "./header-user.vue?vue&type=script&lang=js"
export * from "./header-user.vue?vue&type=script&lang=js"

import "./header-user.vue?vue&type=style&index=0&id=53311009&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53311009"]])

export default __exports__